import React, { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import Homepage from "./pages/Homepage";
import Layout from "./pages/layout";

function App() {
  const [activeSection, setActiveSection] = useState("intro");

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Homepage />} />
          {/* <Route
            path=""
            element={<MonthlyBonusCalculator />}
          />
          <Route
            path="stake-weekly-bonus-calculator"
            element={<WeeklyCalculator />}
          /> */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
